import { EmailThread } from "../../../Components/MailApp/MailAppInterfaces";

import LaundryHeader from "./TimeSquareMailAssets/Laundry.png";
import ClothingHeader from "./TimeSquareMailAssets/Clothing.png";
import PremiumGirlsHeader from "./TimeSquareMailAssets/NYPremiumGirls.png";
import UniversityCollegeHeader from "./TimeSquareMailAssets/UniversityCollege.png";

export const TimeSquareMail: EmailThread[] = [
  {
    Emails: [
      {
        Date: "18 Aug 2024",
        Time: "3:16pm",
        Author: "rainnshinelaundry@mail.co",
        Receiver: "shaunawilliams@mail.co",
        Subject: "Your electronic receipt",
        Text: "Thank you for choosing Rain n Shine Laundry. The receipt for your $24.99 wash and dry service is here",
        imageContent: LaundryHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "14 Aug 2024",
        Time: "6:34pm",
        Author: "brownbear@mail.co",
        Receiver: "shaunawilliams@mail.co",
        Subject: "Your refund request",
        Text: "Hi Shauna\n\nYour refund is being processed. It will be with you in 2-3 working days.",
        imageContent: ClothingHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "9 Aug 2024",
        Time: "3:21pm",
        Author: "NewYorkSubway@MTA.co",
        Receiver: "shaunawilliams@mail.co",
        Subject: "Weekend Travel Advice",
        Text: `Dear Customer,

As we gear up for another bustling summer weekend in New York City, we want to ensure you have a smooth and enjoyable travel experience on our subway system. Here are some important tips to keep in mind this weekend:

Beat the Heat:
*Stay Hydrated: With temperatures soaring, make sure to carry a water bottle. Many stations have refillable water stations to help you stay cool. 
* Dress Lightly: Opt for breathable fabrics to keep comfortable while waiting on platforms.

Travel Smart:
* Check Service Updates: Before you head out, check our website or app for any service changes or delays. This will help you plan your trip efficiently. 
* Avoid Peak Hours: If possible, travel during off-peak times. Mid-morning and early afternoon are usually less crowded.  

Stay Informed: 
* Follow Us: Stay updated on service changes and real-time alerts by following us on social media. We’ll keep you informed on any developments that may affect your travels.

Enjoy The Ride:
* Explore the City: Summer is a great time to enjoy the parks and events happening across the city. Make the most of your weekend by visiting your favorite spots or discovering new ones!

Thank you for riding with us, and stay cool out there!  

Safe travels, 
The NYC Subway Authority`,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "6 Aug 2024",
        Time: "8:53pm",
        Author: "NYpremiumgirls@mail.co",
        Receiver: "shaunawilliams@mail.co",
        Subject: "New Message",
        Text: "You have received a new message\n\nShauna, you have received a message from ace_Y_769.\nLogin to respond now and arrange a meeting.",
        imageContent: PremiumGirlsHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "29 Jul 2024",
        Time: "7:45am",
        Author: "AlbanyBooks@mail.co",
        Receiver: "shaunawilliams@mail.co",
        Subject: "Buy 3 books and get a 4th FREE!",
        Text: "Order online or come and see us in store at Albany Books to get your special member’s discount.",
      },
    ],
  },
  {
    Emails: [
      {
        Date: "18 Jul 2024",
        Time: "10:19am",
        Author: "NYuniversitycollege@mail.co",
        Receiver: "shaunawilliams@mail.co",
        Subject: "Dr. Olayemi Okeke is speaking at NYUC",
        Text: `Join us at the Schwartz building on Thursday 25 July for an evening with Dr. Olayemi Okeke as part of our Postcolonial Histories and Thought lecture series.

Dr. Okeke will be delivering a lecture on Urban Life and Culture in Lagos during the Second Republic.`,
        imageContent: UniversityCollegeHeader,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "12 Jul 2024",
        Time: "7:14pm",
        Author: "NYpremiumgirls@mail.co",
        Receiver: "shaunawilliams@mail.co",
        Subject: "New Message",
        Text: "You have received a new message\n\nShauna, you have received a message from ftz_1429.\nLogin to respond now and arrange a meeting.",
        imageContent: PremiumGirlsHeader,
      },
    ],
  },
];
